import { Webline } from 'components/Layout/Webline/Webline';
import {
    BrandItemStyled,
    GroupHeaderStyled,
    GroupWrapperStyled,
    ListWrapperStyled,
    WrapperStyled,
} from 'components/Pages/Brands/Brands.style';
import { useBrands } from 'connectors/brands/Brands';
import useTranslation from 'next-translate/useTranslation';

const Brands: FC = () => {
    const testIdentifier = 'blocks-brands';

    const { t } = useTranslation();
    const brands = useBrands();

    if (brands === undefined) {
        return null;
    }

    return (
        <Webline>
            <h1 data-testid="basic-heading-h1">{t('Overview of product lines')}</h1>
            <WrapperStyled>
                {brands.map((groupedBrand, groupKey) => (
                    <GroupWrapperStyled key={groupedBrand.firstLetter}>
                        <GroupHeaderStyled>{groupedBrand.firstLetter}</GroupHeaderStyled>
                        <ListWrapperStyled>
                            {groupedBrand.brands.map((brand, brandKey) => (
                                <BrandItemStyled
                                    key={brand.slug}
                                    data-testid={testIdentifier + '-' + (groupKey + 1) + (brandKey + 1)}
                                    href={brand.slug}
                                    type="brand"
                                >
                                    {brand.name}
                                </BrandItemStyled>
                            ))}
                        </ListWrapperStyled>
                    </GroupWrapperStyled>
                ))}
            </WrapperStyled>
        </Webline>
    );
};

export default Brands;
